module.exports = __webpack_public_path__ + "static/media/DavidJM.533fa4a1.png";